import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useActions, useTypedSelector } from 'hooks'
import { Club } from '@fable/types'
import { FORM_TYPES } from 'app/auth/constants'
import { ClubDetailPlanUpsellModal } from './ClubDetailPlanUpsellModal'

export interface ClubDetailTrialDisclosureProps {
  hidden: boolean
  club: Club
}

export const ClubDetailTrialDisclosure = ({
  hidden,
  club,
}: ClubDetailTrialDisclosureProps) => {
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const { openModal, openAuthModal, postAuthPlanUpsell } = useActions()
  const { colors, motion, nativeOverrides } = useTheme()

  if (hidden) return null

  const handleOnClick = () => {
    if (!isAuthenticated) {
      openAuthModal(FORM_TYPES.SIGN_UP, null, [postAuthPlanUpsell({ club })])
      return
    }

    openModal(<ClubDetailPlanUpsellModal club={club} />, 'm-card')
  }

  return (
    <Text
      data-testid="clubDetailTrialDisclosure"
      className={css`
        margin-top: 8px;
      `}
      type="label"
      sizing="L"
      color={colors.hurricane}
    >
      $69.99/year after your 14-day free trial.
      <br />
      <button
        className={css`
          ${nativeOverrides.buttonClear};
          cursor: pointer;
          text-decoration: underline;
          color: ${colors.hurricane};
          ${motion.transition('color')};
          &:hover {
            color: ${colors.graphite};
          }
        `}
        onClick={handleOnClick}
      >
        Shop other plans
      </button>
      .
    </Text>
  )
}
